import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  makeStyles,
  Paper,
  Grid,
  FormControl,
  OutlinedInput,
  InputAdornment,
  InputBase,
  Select,
  withStyles,
  MenuItem,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import { Pagination, PaginationItem } from "@material-ui/lab";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import { Select as AntSelect } from "antd";

import {
  getSubjectMasterSettings,
  saveSubjectMasterSettings,
  clearSubjects,
  downloadSubjectMaster,
} from "../../../actions/admin-actions";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import { UploadIcon, DownloadIcon } from "../../../shared-resources/SVGIcons";
import {
  downloadFile,
  getPaginationPageNumber,
  getResponse,
} from "../../../shared-resources/utils";
import CustomTextField from "../../../common-components/CustomTextField";
import { created_by } from "../../../shared-resources/dumpData";

const { Option } = AntSelect;

const useStyles = makeStyles((theme) => ({
  componentStyles: {},
  tablePaper: {
    borderRadius: "12px",
    padding: "12px",
  },
  searchSection: {
    marginBottom: "4px",
  },
  searchTextField: {
    borderRadius: "25px",
    fontSize: "14px",
    height: "36px",
  },
  searchIcon: {
    color: "#ccc",
  },
  addBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "1px solid #3599d1",
    color: "#ffff",
    backgroundColor: "#0176d3",
    borderRadius: "25px",
    margin: "2px 0 2px 80px",
  },
  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  updateBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    color: "#ffff",
    backgroundColor: "#0176d3",
    borderRadius: "25px",
    marginRight: "8px",
  },
  checkCircleIcon: {
    fontSize: "18px",
    color: "#075e07",
    cursor: "pointer",
    marginTop: "2px",
  },
  checkCircleIconSpan: {
    cursor: "pointer",
    marginLeft: "2px",
  },
  paginationSection: {
    marginTop: "4px",
  },
  searchSection: {
    marginBottom: "4px",
  },
  editIcon: {
    fontSize: "16px",
    color: "#0070D2",
    cursor: "pointer",
  },
  editTextField: {
    height: "24px",
    fontSize: "12px",
    width: "180px",
    padding: "2px",
    background: "#fff",
  },
  editText: {
    padding: "0",
  },

  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    fontSize: "13px",
  },

  addDialog: {
    width: "350px",
    height: "auto",
    position: "relative",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  required: {
    color: "red",
  },
  saveBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "none",
    color: "#ffff",
    backgroundColor: "#0176d3",
    marginRight: "8px",
  },
  statusDropdown: {
    marginTop: "2px",
    width: "100px",
  },
}));

export default function Subjects() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isEnabled, setIsEnabled] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isAdded, setIsAdded] = useState(false);
  const [isValueUpdated, setIsValueUpdated] = useState(false);
  const [newValue, setNewValue] = useState("");
  const [codeVal, setCodeVal] = useState("");
  const [openDialogAdd, setOpenDialogAdd] = useState(false);
  const [isDownloadClick, setIsDownloadClick] = useState(false);

  const subjectsData = useSelector((state) => state.adminReducer.subjectsData);

  const updatedSubjectsData = useSelector(
    (state) => state.adminReducer.updatedSubjectsData
  );

  const downloadSubjectsData = useSelector(
    (state) => state.adminReducer.downloadSubjectsData
  );

  const clearData = () => {
    dispatch(clearSubjects());
  };

  useEffect(() => {
    return () => clearData();
  }, []);

  useEffect(() => {
    dispatch(getSubjectMasterSettings());
    setLoading(true);
  }, []);

  useEffect(() => {
    if (downloadSubjectsData.type && isDownloadClick) {
      setLoading(false);
      downloadFile(downloadSubjectsData, "subjects");
      setIsDownloadClick(false);
    }
  }, [downloadSubjectsData]);

  useEffect(() => {
    if (
      subjectsData.status &&
      (subjectsData.status === 200 || subjectsData.status === 400)
    ) {
      setLoading(false);
    }
    if (subjectsData.status && subjectsData.status === 200) {
      const data = getResponse(subjectsData, []);
      data.forEach((val, i) => {
        val.isEdit = false;
        val.tempId = i + 1;
      });
      setTableData(data);
    }
  }, [subjectsData]);

  useEffect(() => {
    if (
      isValueUpdated &&
      updatedSubjectsData.status &&
      updatedSubjectsData.status === 200
    ) {
      setLoading(false);
      setIsValueUpdated(false);
      setIsEnabled(false);
      setMsgType("Success");
      setEmptyErrMsg(true);
      if (isAdded) {
        setMsgText(`Subjects added successfully`);
        setIsAdded(false);
      } else setMsgText(`Subjects updated successfully`);
      dispatch(getSubjectMasterSettings());
    }
    if (
      isValueUpdated &&
      updatedSubjectsData.status &&
      updatedSubjectsData.status === 400
    ) {
      setLoading(false);
      setIsValueUpdated(false);
    }
  }, [isValueUpdated, updatedSubjectsData]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const onAddClick = () => {
    setNewValue("");
    setOpenDialogAdd(true);
  };

  const downloadSubjects = () => {
    setIsDownloadClick(true);
    dispatch(downloadSubjectMaster());
    setLoading(true);
  };

  const cancelUpdate = () => {
    const data = getResponse(subjectsData, []);
    data.forEach((val, i) => {
      val.isEdit = false;
      val.tempId = i + 1;
    });
    setTableData(data);
    setIsEnabled(false);
  };

  const updateData = () => {
    let isValid = true;
    tableData.forEach((val) => {
      if (val.subject.trim().length > 80) {
        isValid = false;
      }
    });
    if (!isValid) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`
        Subject should not have more than 80 characters`);
      return;
    }
    if (tableData.filter((item) => !item.subjectId).length > 0)
      setIsAdded(true);
    const editedValueExists = tableData.some((existingItem) => {
      if (existingItem.isEdit) {
        const editedValueLowerCase = existingItem.subject.toLowerCase();
        return tableData.some((otherItem) => {
          if (existingItem.tempId !== otherItem.tempId) {
            const otherValueLowerCase = otherItem.subject.toLowerCase();
            return editedValueLowerCase === otherValueLowerCase;
          }
          return false;
        });
      }
      return false;
    });
    if (editedValueExists) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Subject already exists`);
      setLoading(false);
      return;
    }
    tableData.forEach((val) => {
      if (val.subject.trim() === "" && isValid) isValid = false;
    });
    if (!isValid) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Subject cannot be empty`);
      setLoading(false);
      return false;
    }
    setLoading(true);
    setIsValueUpdated(true);
    dispatch(saveSubjectMasterSettings(tableData));
  };

  const onChangeValue = (e, id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) val.subject = e.target.value;
    });
    setTableData(changedData);
    setIsEnabled(true);
  };

  const changeEditStatus = (id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) val.isEdit = !val.isEdit;
    });
    setTableData(changedData);
  };

  const onStatusChange = (value, id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.tempId === id) val.status = value;
    });
    setTableData(changedData);
    setIsEnabled(true);
  };

  const filterData = () => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    if (searchText.trim() !== "") {
      return changedData.filter(
        (val) =>
          val.subject
            .toString()
            .trim()
            .toLowerCase()
            .includes(searchText.toString().trim().toLowerCase()) ||
          val.subjectCode
            .toString()
            .trim()
            .toLowerCase()
            .includes(searchText.toString().trim().toLowerCase())
      );
    }
    return changedData;
  };

  const handleCloseDialogAdd = () => {
    setOpenDialogAdd(false);
  };

  const onChangeValueNew = (e) => {
    setNewValue(e.target.value);
  };

  const onCodeChange = (e) => {
    setCodeVal(e.target.value);
  };

  const onAddSubjectClick = () => {
    if (newValue.toString().trim() === "") {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter new subject`);
      return;
    }
    if (newValue.toString().trim().length > 80) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Subject should not have more than 80 characters`);
      return;
    }
    if (
      tableData.find(
        (val) =>
          val.subject.toLowerCase() === newValue.toString().trim().toLowerCase()
      )
    ) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Subject already exists`);
      return;
    }
    const maxIndex = Math.max(...tableData.map((o) => o.tempId));
    setTableData([
      {
        subject: newValue,
        subjectCode: 0,
        created_by: created_by,
        created_date: new Date(),
        status: "Active",
        tempId: maxIndex + 1,
      },
      ...tableData,
    ]);
    setIsEnabled(true);
    setOpenDialogAdd(false);
  };

  const onCancelClick = () => {
    setOpenDialogAdd(false);
  };

  return (
    <Paper elevation={0} className={classes.tablePaper}>
      <Grid container className={classes.searchSection} spacing={0}>
        <Grid item lg={6}>
          <FormControl variant="outlined" className={classes.searchControl}>
            <OutlinedInput
              className={classes.searchTextField}
              type="text"
              placeholder="Search"
              onChange={(e) => onSearchChange(e)}
              value={searchText}
              endAdornment={
                <InputAdornment position="start">
                  <SearchIcon className={classes.searchIcon} />
                </InputAdornment>
              }
            />
          </FormControl>
          <Button
            className={classes.addBtn}
            variant="contained"
            color="primary"
            onClick={onAddClick}
          >
            Add Subject
          </Button>
        </Grid>
        <Grid item lg={6} style={{ position: "relative" }}>
          <Button
            variant="outlined"
            className={classes.cancelBtn}
            color="primary"
            onClick={() => cancelUpdate()}
            disabled={!isEnabled}
            style={{ marginTop: "4px", float: "right" }}
          >
            Cancel
          </Button>
          <Button
            className={classes.updateBtn}
            variant="contained"
            color="primary"
            onClick={updateData}
            disabled={!isEnabled}
            style={{ marginTop: "4px", float: "right" }}
          >
            Update
          </Button>
          <span
            style={{
              cursor: "pointer",
              marginRight: "6px",
              float: "right",
              marginTop: "-3px",
            }}
            title="Download Subjects"
            onClick={() => downloadSubjects()}
          >
            <DownloadIcon background="#0070D2" color="#fff" />
          </span>
        </Grid>
      </Grid>
      {filterData(tableData).length > 0 ? (
        <table className="generalSettingsTable">
          <thead>
            <tr>
              <td>Subject</td>
              <td>Subject Code</td>
              <td>Status</td>
            </tr>
          </thead>
          <tbody>
            {filterData(tableData)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((tableItem, i) => (
                <tr key={i}>
                  <td>
                    <span style={{ float: "left" }}>
                      {tableItem.isEdit ? (
                        <FormControl
                          variant="outlined"
                          className={classes.editText}
                        >
                          <OutlinedInput
                            className={classes.editTextField}
                            type="text"
                            onChange={(e) => onChangeValue(e, tableItem.tempId)}
                            value={tableItem.subject}
                            inputProps={{
                              style: {
                                padding: "0 0 0 2px",
                              },
                            }}
                          />
                        </FormControl>
                      ) : (
                        tableItem.subject
                      )}
                    </span>

                    {tableItem.isEdit ? (
                      <span className={classes.checkCircleIconSpan}>
                        <CheckCircleIcon
                          className={classes.checkCircleIcon}
                          onClick={() => changeEditStatus(tableItem.tempId)}
                        />
                      </span>
                    ) : (
                      <span className="settinsTableEdit">
                        <EditIcon
                          className={classes.editIcon}
                          onClick={() => changeEditStatus(tableItem.tempId)}
                        />
                      </span>
                    )}
                  </td>
                  <td>{tableItem.subjectCode}</td>
                  <td>
                    {tableItem.isEdit ? (
                      <AntSelect
                        mode="single"
                        className={classes.statusDropdown}
                        value={tableItem.status}
                        onChange={(value) =>
                          onStatusChange(value, tableItem.tempId)
                        }
                      >
                        <Option key="Active" value="Active">
                          Active
                        </Option>
                        <Option key="Inactive" value="Inactive">
                          Inactive
                        </Option>
                      </AntSelect>
                    ) : (
                      tableItem.status
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <div
          style={{ textAlign: "center", padding: "20px 0", fontWeight: 600 }}
        >
          No results found
        </div>
      )}
      {filterData(tableData).length > 0 && (
        <Grid container className={classes.paginationSection} spacing={0}>
          <Grid item lg={12}>
            <div style={{ float: "right", marginTop: "6px" }}>
              <Pagination
                count={Math.ceil(filterData(tableData).length / rowsPerPage)}
                showFirstButton
                showLastButton
                page={page + 1}
                onChange={handleChangePage}
                color="primary"
                style={{ float: "right" }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    page={getPaginationPageNumber(
                      item.page - 1,
                      filterData(tableData).length,
                      rowsPerPage
                    )}
                  />
                )}
              />
            </div>
            <div style={{ float: "right", marginTop: "6px" }}>
              <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
              <FormControl className="tableRowsDdl">
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  input={<BootstrapInput />}
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      )}
      <Dialog
        open={openDialogAdd}
        onClose={handleCloseDialogAdd}
        aria-labelledby="max-width-dialog-title"
        // disableBackdropClick
      >
        <DialogContent className={classes.addDialog}>
          <div className={classes.popupHeader}>
            <span
              className={classes.closeIconAdd}
              onClick={() => setOpenDialogAdd(false)}
            >
              x
            </span>
            <div className={classes.addColumnTitle}>Add Subject</div>
          </div>
          <Grid container spacing={2}>
            <Grid item lg={12}>
              <div className={classes.fieldTitle}>
                Subject<span className={classes.required}>*</span>
              </div>
              <CustomTextField
                selectedValue={newValue}
                onChangeItem={onChangeValueNew}
                labelVal="Subject"
                id="subjectName"
              />
            </Grid>
          </Grid>
          <div className={classes.popupBtnsAdd}>
            <Button
              className={classes.saveBtn}
              variant="contained"
              color="primary"
              onClick={onAddSubjectClick}
              disabled={newValue.trim() === ""}
            >
              Add
            </Button>
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              color="primary"
              onClick={onCancelClick}
            >
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </Paper>
  );
}
